<div class="accounts-tab">
  <div class="accounts-tab__toolbar">
    <div class="accounts-tab__actions">
      <button type="button" class="button button--primary" (click)="openProjectAccountModal()">
        <i class="fa fa-plus m-r-1"></i> Contract toevoegen
      </button>
      <button
        *ngIf="hasPastContracts"
        type="button"
        class="button button--outline"
        (click)="togglePastContracts()">
        {{ showPastContracts ? 'Verberg afgelopen contracten' : ('Toon afgelopen contracten (' + pastAccountsCount + ')') }}
      </button>
    </div>
    <small class="text-muted">
      Actief: {{ activeAccountsCount }}
      <span *ngIf="hasPastContracts"> • Afgelopen: {{ pastAccountsCount }}</span>
    </small>
  </div>
  <div *ngIf="loading" class="text-center my-3">
    <i class="fa fa-spinner fa-spin"></i> Loading accounts...
  </div>

  <div *ngIf="!loading">
    <div *ngIf="accounts && accounts.length > 0; else noAccounts">
      <div class="table__overflow">
        <table class="table-view">
          <thead>
            <tr>
              <th>Account</th>
              <th>Employees</th>
              <th>Price</th>
              <th>Budget (€)</th>
              <th>Budgeted hours</th>
              <th>Actual hours</th>
              <th>Hours left</th>
              <th>Budget indicatie</th>
              <th>Effective From</th>
              <th>Effective To</th>
              <th>Purchase order (PO)</th>
              <th>SES / invoicing approval</th>
              <th>Contract / MSA number</th>
              <th>Invoice free text</th>
              <th>Contract</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let acc of displayedAccounts">
              <td>{{ getAccountDisplay(acc) }}</td>
              <td>
                <ng-container *ngIf="acc.employeeIds?.length; else noEmployees">
                  <app-pill-employee
                    *ngFor="let employeeId of acc.employeeIds"
                    [employeeId]="employeeId"
                    class="m-r-1">
                  </app-pill-employee>
                </ng-container>
                <ng-template #noEmployees>-</ng-template>
              </td>
              <td>{{ acc.price }}</td>
              <td>{{ acc.budget != null ? (acc.budget | number: '1.2-2') : '-' }}</td>
              <td>{{ getBudgetedHours(acc) != null ? (getBudgetedHours(acc) | number: '1.2-2') : '-' }}</td>
              <td>{{ getActualHours(acc) | number: '1.2-2' }}</td>
              <td>{{ getHoursLeft(acc) != null ? (getHoursLeft(acc) | number: '1.2-2') : '-' }}</td>
              <td
                [matTooltip]="acc.budget != null ? getBudgetProgressTooltip(acc) : ''"
                matTooltipPosition="above"
                matTooltipShowDelay="150"
                matTooltipClass="budget-tooltip">
                <ng-container *ngIf="acc.budget != null; else noBudgetIndicator">
                  <ng-container *ngIf="isBudgetLoading(acc); else accountBudgetLoaded">
                    <i class="fa fa-spinner fa-spin"></i>
                  </ng-container>
                  <ng-template #accountBudgetLoaded>
                  <div class="budget-progress"
                    [matTooltip]="getBudgetProgressTooltip(acc)"
                    matTooltipPosition="above"
                    matTooltipShowDelay="150"
                    matTooltipClass="budget-tooltip">
                    <small class="d-block"><strong>Budget by worklogs</strong></small>
                    <mat-progress-bar
                      class="budget-progress__track"
                      [value]="getBudgetProgress(acc)"
                      [ngClass]="{ 'warning': getBudgetProgressRaw(acc) >= 70 && getBudgetProgressRaw(acc) <= 100, 'danger': getBudgetProgressRaw(acc) > 100 }"
                      mode="determinate">
                    </mat-progress-bar>
                    <span class="budget-progress__label">{{ getBudgetProgressRaw(acc) | number: '1.0-0' }}%</span>
                  </div>
                  <small>
                    € {{ getActualCostWithInvoices(acc) | number: '1.2-2' }} / € {{ acc.budget | number: '1.2-2' }}
                    <span *ngIf="getBudgetProgressRaw(acc) > 100">(over budget)</span>
                  </small>
                  <div class="budget-progress m-t-1"
                    [matTooltip]="getBudgetByInvoiceTooltip(acc)"
                    matTooltipPosition="above"
                    matTooltipShowDelay="150"
                    matTooltipClass="budget-tooltip">
                    <small class="d-block"><strong>Budget by invoice</strong></small>
                    <mat-progress-bar
                      class="budget-progress__track"
                      [value]="getBudgetByInvoiceProgress(acc)"
                      [ngClass]="{ 'warning': getBudgetByInvoiceProgressRaw(acc) >= 70 && getBudgetByInvoiceProgressRaw(acc) <= 100, 'danger': getBudgetByInvoiceProgressRaw(acc) > 100 }"
                      mode="determinate">
                    </mat-progress-bar>
                    <span class="budget-progress__label">{{ getBudgetByInvoiceProgressRaw(acc) | number: '1.0-0' }}%</span>
                  </div>
                  <small>
                    € {{ getSalesInvoicesAmount(acc) | number: '1.2-2' }} / € {{ acc.budget | number: '1.2-2' }}
                    <span *ngIf="getBudgetByInvoiceProgressRaw(acc) > 100">(over budget)</span>
                  </small>
                  </ng-template>
                </ng-container>
                <ng-template #noBudgetIndicator>-</ng-template>
              </td>
              <td>{{ acc.effectiveFrom || '-' }}</td>
              <td>{{ acc.effectiveTo || '-' }}</td>
              <td>{{ acc.poNumber || '-' }}</td>
              <td>{{ acc.sesNumber || '-' }}</td>
              <td>{{ acc.contractAgreementNumber || '-' }}</td>
              <td>{{ acc.freeText || '-' }}</td>
              <td>
                <ng-container *ngIf="acc.contractUrl; else noContract">
                  <a [href]="acc.contractUrl" download target="_blank" title="Download contract">
                    <i class="las la-paperclip"></i>
                    <span class="m-l-1">{{ acc.contractFileName || (acc.contractUrl?.split('/')?.pop()) }}</span>
                  </a>
                </ng-container>
                <ng-template #noContract>-</ng-template>
              </td>
              <td>
                <button type="button" class="btn btn-link p-0 m-r-2 text-primary" title="Bewerken" (click)="openEditProjectAccountModal(acc)">
                  <i class="las la-pen"></i>
                </button>
                <button type="button" class="btn btn-link p-0 text-danger" title="Verwijderen" (click)="removeProjectAccount(acc.uuid)">
                  <i class="las la-trash"></i>
                </button>
              </td>
            </tr>
            <tr *ngIf="!showPastContracts && displayedAccounts.length === 0">
              <td colspan="16" class="text-muted">Geen actieve contracten. Klik op "Toon afgelopen contracten" om verlopen contracten te zien.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <ng-template #noAccounts>
      <div class="text-muted">No contracts linked to this project yet.</div>
    </ng-template>
  </div>
</div>
